"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    initMetadataManager: ()=>initMetadataManager,
    inlineMetadataManager: ()=>inlineMetadataManager
});
const initMetadataManager = ()=>{
    let locationPins = {};
    let hotelOnMap = {};
    return {
        getLocationPinList: ()=>Object.values(locationPins),
        getHotelOnMapList: ()=>Object.values(hotelOnMap),
        appendNewPinToList: ({ singlePin, listOfPins = [] })=>{
            if (0 !== listOfPins.length) listOfPins.forEach((pin)=>{
                locationPins = {
                    ...locationPins,
                    [pin.name]: pin
                };
            });
            else if (singlePin) locationPins = {
                ...locationPins,
                [singlePin.name]: singlePin
            };
        },
        setHotelPinOnMap: (list)=>{
            locationPins = {};
            list.forEach((hotel)=>{
                if (hotel.hotelId) hotelOnMap = {
                    ...hotelOnMap,
                    [hotel.hotelId]: hotel
                };
                else if (hotel.name) hotelOnMap = {
                    ...hotelOnMap,
                    [hotel.name]: hotel
                };
            });
        },
        reset: ()=>{
            hotelOnMap = {};
            locationPins = {};
        }
    };
};
const inlineMetadataManager = initMetadataManager();
exports.initMetadataManager = __webpack_exports__.initMetadataManager;
exports.inlineMetadataManager = __webpack_exports__.inlineMetadataManager;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "initMetadataManager",
    "inlineMetadataManager"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
